import React from 'react';
import { Provider } from 'react-redux';

import Router from './Router';
import store from './store';

function App() {
  return (
    <React.StrictMode>
      <Provider store={store}>
        <Router />
      </Provider>
    </React.StrictMode>
  );
}

export default App;
